export default "__VITE_ASSET__BDyS04dp__"